import { useNavigate } from 'react-router-dom';

import { SliderOver } from '@/components';
import MenuLogo from '@/components/Navbar/MenuLogo';
import usePinsAccount from '@/hooks/usePinsAccount';
import ROUTES from '@/router/routes';
import { cn } from '@/utils';

type Props = {
  isOpen: boolean;
  handleOpen: (val: boolean) => void;
};

const MobileMenu = ({ isOpen, handleOpen }: Props) => {
  const { pinsData } = usePinsAccount();
  const navigate = useNavigate();

  return (
    <SliderOver
      closeIconClassName="text-white"
      handleClose={() => handleOpen(false)}
      open={isOpen}
    >
      <div className="flex flex-col">
        <header
          className={cn('py-8 pl-8 bg-gdt-blue-header space-y-6', {
            'bg-gdt-gray premium': pinsData.isPremium,
          })}
        >
          <div className="flex items-center justify-start">
            <div className="pr-5">
              <MenuLogo className="max-w-[32px] w-full" />
            </div>
            <div
              className={cn('border-l border-[#3366FF] space-y-1 pl-4', {
                'border-gdt-gray-3': pinsData.isPremium,
              })}
            >
              <p
                className="text-sm text-white font-semibold cursor-pointer"
                onClick={() => navigate(ROUTES.basePath)}
              >
                INGRESAR
              </p>
            </div>
          </div>
        </header>
      </div>
    </SliderOver>
  );
};

export default MobileMenu;
